import React, { createContext, useContext, useEffect, useState } from "react";
import { FilterContext } from "./Filter";
import {
  getBandhuappJc,
  getClosedjcBs6,
  getClosedJcNonBs6,
  getFsclYrData,
  getJcServiceAnalysis,
  getjcServiceAnalysis_non_bs6,
  getJcServiceAnalysisBs6,
  getLastThreeDetailBox,
  getLastThreeDetailPopup,
  getLobData,
  getLobWiseJcData,
  getOpenJcBs6,
  getOpenJcNonBs6,
  getOpenJobcard,
  getPlData,
  getPplData,
  getSparesSales,
  getStateListData,
  getStateWiseJc,
  getTotaljcBs6,
  getTotalJcNonBs6,
  getTotalJobcard,
} from "../pages/piplineAndService/servicesKpi";
import { useQuery } from "@tanstack/react-query";

export const ServicesContext = createContext();

const ServicesDataProvider = ({ children }) => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const arn = parArn || childArn;
  const [closeJobCardData, setCloseJobCardData] = useState(null);
  // 1.
  const {
    data: jcServiceAnalysisData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["jcServiceAnalysis", arn],
    queryFn: () => getJcServiceAnalysis(arn),
    enabled: !!arn,
  });
  // 2.
  const {
    data: jcServiceAnalysisBs6Data,
    isJcServiceAnalysisBs6Loading,
    isJcServiceAnalysisBs6Error,
  } = useQuery({
    queryKey: ["JcServiceAnalysisBs6", arn],
    queryFn: () => getJcServiceAnalysisBs6(arn),
    enabled: !!arn,
  });
  // 3.
  const {
    data: jcServiceAnalysis_non_bs6Data,
    isgetjcServiceAnalysis_non_bs6Loading,
    isgetjcServiceAnalysis_non_bs6Error,
  } = useQuery({
    queryKey: ["jcServiceAnalysis_non_bs6", arn],
    queryFn: () => getjcServiceAnalysis_non_bs6(arn),
    enabled: !!arn,
  });
  // 4.
  const {
    data: totalJobcardData,
    isTotalJobcardLoading,
    isTotalJobcardError,
  } = useQuery({
    queryKey: ["totalJobcard", arn],
    queryFn: () => getTotalJobcard(arn),
    enabled: !!arn,
  });

  // 5.
  const {
    data: openJobcardData,
    isOpenJobcardLoading,
    isOpenJobcardError,
  } = useQuery({
    queryKey: ["openJobcard", arn],
    queryFn: () => getOpenJobcard(arn),
    enabled: !!arn,
  });

  //  console.log("TotalJobCardData", totalJobcardData.doc_count)
  // console.log("OpenJobCardData", openJobcardData.doc_count)

  // 6.
  const {
    data: bandhuappJcData,
    isbandhuappJcLoading,
    isbandhuappJcError,
  } = useQuery({
    queryKey: ["bandhuappJc", arn],
    queryFn: () => getBandhuappJc(arn),
    enabled: !!arn,
  });
  // 7.
  const {
    data: totalJcBs6Data,
    isTotaljcBs6Loading,
    isTotaljcBs6Error,
  } = useQuery({
    queryKey: ["totaljcBs6", arn],
    queryFn: () => getTotaljcBs6(arn),
    enabled: !!arn,
  });

  // 8.
  const {
    data: openJcBs6Data,
    isOpenJcBs6Loading,
    isOpenJcBs6Error,
  } = useQuery({
    queryKey: ["openJcBs6", arn],
    queryFn: () => getOpenJcBs6(arn),
    enabled: !!arn,
  });
  // console.log("openJcBs6Data", openJcBs6Data)
  // 9.
  const {
    data: closedjcBs6Data,
    isClosedjcBs6Loading,
    isClosedjcBs6Error,
  } = useQuery({
    queryKey: ["closedjcBs6", arn],
    queryFn: () => getClosedjcBs6(arn),
    enabled: !!arn,
  });
  // console.log("closedjcBs6Data", closedjcBs6Data)
  // 10.
  const {
    data: totalJcNonBs6Data,
    isTotalJcNonBs6Loading,
    isTotalJcNonBs6Error,
  } = useQuery({
    queryKey: ["totalJcNonBs6", arn],
    queryFn: () => getTotalJcNonBs6(arn),
    enabled: !!arn,
  });

  // 11.
  const {
    data: openJcNonBs6Data,
    isOpenJcNonBs6Loading,
    isOpenJcNonBs6Error,
  } = useQuery({
    queryKey: ["openJcNonBs6", arn],
    queryFn: () => getOpenJcNonBs6(arn),
    enabled: !!arn,
  });
  // console.log("openJcNonBs6Data", openJcNonBs6Data)
  // 12.
  const {
    data: closedJcNonBs6Data,
    isClosedJcNonBs6Loading,
    isClosedJcNonBs6Error,
  } = useQuery({
    queryKey: ["closedJcNonBs6", arn],
    queryFn: () => getClosedJcNonBs6(arn),
    enabled: !!arn,
  });
  // console.log("closedJcNonBs6Data", closedJcNonBs6Data)
  // 13.
  const {
    data: lastThreeDetailBoxData,
    isLastThreeDetailBoxLoading,
    isLastThreeDetailBoxError,
  } = useQuery({
    queryKey: ["lastThreeDetailBox", arn],
    queryFn: () => getLastThreeDetailBox(arn),
    enabled: !!arn,
  });

  // 14.
  const {
    data: lastThreeDetailPopupData,
    isLastThreeDetailPopupLoading,
    isLastThreeDetailPopupError,
  } = useQuery({
    queryKey: ["lastThreeDetailPopup", arn],
    queryFn: () => getLastThreeDetailPopup(arn),
    enabled: !!arn,
  });

  // 15.
  const {
    data: sparesSalesData,
    isSparesSalesLoading,
    isSparesSalesError,
  } = useQuery({
    queryKey: ["sparesSales", arn],
    queryFn: () => getSparesSales(arn),
    enabled: !!arn,
  });

  // 18.
  const {
    data: stateWiseJcData,
    isStateWiseJcLoading,
    isStateWiseJcError,
  } = useQuery({
    queryKey: ["stateWiseJc", arn],
    queryFn: () => getStateWiseJc(arn),
    enabled: !!arn,
  });

  // 19.
  const {
    data: lobWiseJcData,
    isLobWiseJcDataLoading,
    isLobWiseJcDataError,
  } = useQuery({
    queryKey: ["lobWiseJc", arn],
    queryFn: () => getLobWiseJcData(arn),
    enabled: !!arn,
  });

  // 20.
  const {
    data: stateListData,
    isStateListDataLoading,
    isStateListDataError,
  } = useQuery({
    queryKey: ["stateList", arn],
    queryFn: () => getStateListData(arn),
    enabled: !!arn,
  });

  // 21.
  const {
    data: pplData,
    ispplDataLoading,
    ispplDataError,
  } = useQuery({
    queryKey: ["ppl", arn],
    queryFn: () => getPplData(arn),
    enabled: !!arn,
  });

  // 22.
  const {
    data: plData,
    isPlDataLoading,
    isPlDataError,
  } = useQuery({
    queryKey: ["pl", arn],
    queryFn: () => getPlData(arn),
    enabled: !!arn,
  });

  //   23.
  const {
    data: lobData,
    isLobDataLoading,
    isLobDataError,
  } = useQuery({
    queryKey: ["lob", arn],
    queryFn: () => getLobData(arn),
    enabled: !!arn,
  });

  //  24.
  const {
    data: fsclYrData,
    isFsclYrDataLoading,
    isFsclYrDataError,
  } = useQuery({
    queryKey: ["FsclYr", arn],
    queryFn: () => getFsclYrData(arn),
    enabled: !!arn,
  });

  // console.log("closeJobcard", closeJobCardData)
  const values = {
    jcServiceAnalysisData,
    jcServiceAnalysisBs6Data,
    jcServiceAnalysis_non_bs6Data,
    totalJobcardData,
    openJobcardData,
    bandhuappJcData,
    totalJcBs6Data,
    openJcBs6Data,
    closedjcBs6Data,
    totalJcNonBs6Data,
    openJcNonBs6Data,
    closedJcNonBs6Data,
    lastThreeDetailBoxData,
    lastThreeDetailPopupData,
    sparesSalesData,
    stateWiseJcData,
    lobWiseJcData,
    stateListData,
    pplData,
    plData,
    lobData,
    fsclYrData,
  };

  return (
    <ServicesContext.Provider value={values}>
      {children}
    </ServicesContext.Provider>
  );
};

export default ServicesDataProvider;
